module.exports = __webpack_public_path__ + "24e004ab/img/grid-web-icon.d0395d64.svg";